import { getStudioGridOptionLabel as getStudioGridOptionLabelByLang } from '../constants/studioGridOptionLabels';

export const getStudioGridOptionLabel = (label, gridOptionLabels, lang) => {
	if (!label) {
		return '';
	}

	if (gridOptionLabels?.[label]) {
		return gridOptionLabels[label];
	}

	if (lang) {
		return getStudioGridOptionLabelByLang(lang, label);
	}

	return label;
};
